import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './AcademicPerformanceStudentsMarksView.css';
// import './ViewDashBoard.css';
import './pri.css';
import './panchayat.css';
import "./admininfo2.css";
import "./prtnm-ui.css";
// import './teacherlessonplan.css';


//import '../../../../AcademicPerformanceStudentsMarksView.css'; 
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import { store } from './store';
import { Provider } from 'react-redux';
// import {ThroughProvider} from 'react-through'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
      {/* <ThroughProvider> */}
    <App />

    {/* </ThroughProvider> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
